import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren, useMemo } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions, LotNote } from "../../api/dtos";

export interface ILotNoteFormByIdRouteProps extends PropsWithChildren {
    lotNoteId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const LotNoteFormByIdRoute: FC<ILotNoteFormByIdRouteProps> = ({
    lotNoteId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const lotNoteIdToUse = (params.lotNoteId ? +params.lotNoteId : undefined) ?? lotNoteId ?? undefined;

    const lotId = params.lotId ? +params.lotId : undefined;

    const createData = useMemo(() => new LotNote({
        lotId: lotId
    }), [lotId]);

    return (
        <ContextFormByIdProvider
            formId={lotNoteIdToUse}
            formDefinitionIdentifier={FormDefinitions.LotNote}
            createData={createData}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default LotNoteFormByIdRoute;
